import React from "react";
import "./Book.css";

const BookNowsec1 = () => {
  return (
    <>
      <div className="book-wrapper">
        <div className="book-image">
          <img src="./image 181 1 (1).png" alt="#" className="imgg" />
          <div className="book-content">
            <p className="book-cont">Contact Us</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default BookNowsec1;
